export enum UserTypeEnum {
  Administrator = 1,
  OfficeStaff = 2,
  ClinicalManager = 3,
  Marketer = 4,
  Clinician = 5
}

export const UserTypeOptions = [
{ id: 1, label: 'Administrator', abbreviation: 'ADM' },
{ id: 2, label: 'Office Staff', abbreviation: 'OFF' },
{ id: 3, label: 'Clinical Manager', abbreviation: 'CM' },
{ id: 4, label: 'Marketer', abbreviation: 'MAR' },
{ id: 5, label: 'Clinician', abbreviation: 'CLN' }
];
